import axios from 'axios'
import { Message } from 'element-ui'
import store from "@/store";

/**
 * 封装的请求模块
 * 使用 axios 库
 * 
 * 使用示例：
 * import request from './path/to/request.js'
 * 
 * request.get('/users', { page: 1 }, response => {
 *   console.log(response.data)
 * }, error => {
 *   console.error(error.message)
 * })
 */
const service = axios.create({
    baseURL: process.env.BASE_API, // 基础url
    timeout: 90000, // 超时时间
    withCredentials: true, // 跨域请求时是否需要凭证
})

service.defaults.crossDomain = true
//Access-Control-Allow-Origin 指向前端 ip:port
service.defaults.headers.common['Access-Control-Allow-Origin'] = process.env.VUE_APP_Access_Control_Allow_Origin;

service.interceptors.request.use(
    config => {
        var token = store.state.userInfo.token
        // console.info("request token:" + token)
        if (token) {
            config.headers['t-token'] = token
        }
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
        return config
    },
    error => {
        return Promise.reject(error)
        // todo: 401，提示登录
    }
)

service.interceptors.response.use(
    response => {
        // console.info(response)
        if (response.status === 200) {
            return response.data
        } else {
            return Promise.reject(new Error('Request failed'))
        }
    },
    error => {
        if (error.response) {
            console.info(error.response.data.message)
            Message({
                message: error.response.data.message,
                type: 'error'
            })
            return Promise.reject(error);
        } else {
            return Promise.reject(new Error('Network error'))
        }
    }
)

// export default {
//     /**
//      * GET 请求
//      * @param {string} url 请求地址
//      * @param {object} params 请求参数，params.path为path参数
//      * @param {function} successCallback 成功回调函数
//      * @param {function} errorCallback 失败回调函数
//      * @returns {void}
//      */
//      get(url, params, successCallback, errorCallback) {
//         // 如果有 path 参数，则拼接到 url 后面，并删除 params 中的 path 属性
//         if (params && params.path) {
//             url += '/' + params.path
//             delete params.path
//         }
//         // 发送 GET 请求
//         request.get(url, { params })
//             .then(response => {
//                 successCallback(response)
//             })
//             .catch(error => {
//                 errorCallback(error)
//             })
//     },
//     /**
//      * POST 请求
//      * @param {string} url 请求地址
//      * @param {object} data 请求数据
//      * @param {function} successCallback 成功回调函数
//      * @param {function} errorCallback 失败回调函数
//      */
//     post(url, data, successCallback, errorCallback) {
//         request.post(url, data)
//             .then(response => {
//                 successCallback(response)
//             })
//             .catch(error => {
//                 errorCallback(error)
//             })
//     },
//     /**
//      * PUT 请求
//      * @param {string} url 请求地址
//      * @param {object} data 请求数据
//      * @param {function} successCallback 成功回调函数
//      * @param {function} errorCallback 失败回调函数
//      */
//     put(url, data, successCallback, errorCallback) {
//         request.put(url, data)
//             .then(response => {
//                 successCallback(response)
//             })
//             .catch(error => {
//                 errorCallback(error)
//             })
//     },
//     /**
//      * DELETE 请求
//      * @param {string} url 请求地址
//      * @param {function} successCallback 成功回调函数
//      * @param {function} errorCallback 失败回调函数
//      */
//     delete(url, successCallback, errorCallback) {
//         request.delete(url)
//             .then(response => {
//                 successCallback(response)
//             })
//             .catch(error => {
//                 errorCallback(error)
//             })
//     }
// }
export default service


// WEBPACK FOOTER //
// ./src/utils/request.js